import "core-js/modules/es.date.to-string.js";
import React from 'react';
import { isAfter, format, differenceInDays } from 'date-fns';
import SidebarRow from "../SidebarRow/SidebarRow";
import { IconTooltip } from '@applyboard/ui-components';
import { InfoOutlineIcon } from '@applyboard/ui-icons';
export var ApplicationDeadlines = function ApplicationDeadlines(props) {
  var _props$application, _props$application2;
  if (!((_props$application = props.application) !== null && _props$application !== void 0 && _props$application.esl_intake_id || (_props$application2 = props.application) !== null && _props$application2 !== void 0 && _props$application2.intake_id)) {
    return null;
  }
  var tooltipText = 'Submission deadlines are displayed in your local timezone';
  var tdbTooltipText = 'We’re not able to calculate deadline at the moment. Please check later.';
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.application.esl_intake_id && /*#__PURE__*/React.createElement(SidebarRow, {
    title: "ESL Submission Deadline",
    key: "ESL Submission Deadline",
    content: /*#__PURE__*/React.createElement("div", null, formatDeadline(props.application.esl_submission_deadline), /*#__PURE__*/React.createElement(IconTooltip, {
      "aria-label": "Additional ESL Deadline Info",
      title: props.application.esl_submission_deadline ? tooltipText : tdbTooltipText,
      icon: /*#__PURE__*/React.createElement(InfoOutlineIcon, {
        color: "secondary"
      })
    }))
  }), props.application.intake_id && /*#__PURE__*/React.createElement(SidebarRow, {
    title: "Academic Submission Deadline",
    key: "Academic Submission Deadline",
    content: /*#__PURE__*/React.createElement("div", null, formatDeadline(props.application.academic_submission_deadline), /*#__PURE__*/React.createElement(IconTooltip, {
      "aria-label": "Additional Academic Deadline Info",
      title: props.application.academic_submission_deadline ? tooltipText : tdbTooltipText,
      icon: /*#__PURE__*/React.createElement(InfoOutlineIcon, {
        color: "secondary"
      })
    }))
  }));
};
var formatDeadline = function formatDeadline(deadline) {
  if (!deadline) {
    return 'To Be Determined';
  }
  var today = new Date();
  var deadlineDate = new Date(deadline);
  return isAfter(deadlineDate, today) && differenceInDays(deadlineDate, today) <= 3 ? format(deadlineDate, 'MMM dd, yyyy, hh:mma, O') : format(deadlineDate, 'MMM dd, yyyy');
};